import { onMount } from "svelte";
import { on } from "svelte/events";
import { getDefaultSubmitter } from "../../../../common/utils/form/form";
import type { Props } from "../ButtonV1.types";

export const useFormEnterHandler = (
  Host: HTMLOcButtonV1Element,
  internals: ElementInternals,
  buttonType: () => Props["type"],
): void => {
  onMount(() => {
    const formEnterHandler = (event: KeyboardEvent): void => {
      /*                                                  */
      if (event.defaultPrevented) return;

      /*                    */
      if (event.key !== "Enter" || buttonType() !== "submit") return;

      const tagName = (event.target as HTMLElement | null)?.tagName;

      /*                              */
      if (tagName === "TEXTAREA") return;

      /*                          */
      /*                                       */
      if (tagName?.startsWith("OC-")) return;

      /*                                                                       */
      if (!Array.from(internals.form?.elements || []).some((e) => e === event.target)) return;

      /*                                                           */
      if (Host !== getDefaultSubmitter(internals.form)) return;

      event.preventDefault();
      /*                                                                               */
      /*                                                */
      Host.click();
    };

    /*                                               */
    return internals.form && on(internals.form, "keydown", formEnterHandler);
  });
};
